import { Button, DataSource, HorizontalSpacer, Label, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierLaneRate extends Layout {
    buttonSearch: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelCommitmentHistory: Label;
    sourceCarrierCommitmentHistory: DataSource;
    sourceCarrierLaneRate: DataSource;
    switchPtToPt: Switch;
    switchSortLast: Switch;
    tabCommitments: Tab;
    tabRate: Tab;
    tableCommitmentHistory: Table;
    tabsetCommitments: Tabset;
    textboxCommitmentAmount: Textbox;
    textboxCommitmentFrequency: Textbox;
    textboxCommitmentsMet: Textbox;
    textboxCommitmentsOffered: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxContactPhone: Textbox;
    textboxDeductCodeDescr: Textbox;
    textboxDescr: Textbox;
    textboxDestination: Textbox;
    textboxDestinationCode: Textbox;
    textboxDestinationCounties: Textbox;
    textboxDestinationState: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxExtraStopPay: Textbox;
    textboxExtraStopPayDeductCode: Textbox;
    textboxFuelSurchargePay: Textbox;
    textboxLastUsedDate: Textbox;
    textboxMinimumPay: Textbox;
    textboxOrigin: Textbox;
    textboxOriginCode: Textbox;
    textboxOriginCounties: Textbox;
    textboxOriginState: Textbox;
    textboxPickupDateRange: Textbox;
    textboxPriority: Textbox;
    textboxRate: Textbox;
    textboxRateMethod: Textbox;
    textboxTimesUsed: Textbox;
}
